import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Tabs, message } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

import Main from '../../components/layout/Main';
import { CombinedStates } from '../../core/types';
import CompetitionGeneralDetails from '../../components/Competitions/CompetitionGeneralDetails';
import CompetitionWinners from '../../components/Competitions/CompetitionWinners';
import './competitionDetail.scss';

const CompetitionDetail = () => {
    const navigate = useNavigate();

    const {
        currentCompetition,
        isFetching,
        error,
    } = useSelector((state: CombinedStates) => state.competition);

    const backLink = (
        <Button onClick={() => navigate('/svietimo-centro-rodikliai', {
            state: { activeTab: '2' }, // '2' is the key for "Konkursai" tab
        })}>
            <LeftOutlined /> Atgal
        </Button>
    );

    const handleBack = () => {
        navigate('/svietimo-centro-rodikliai', {
            state: { activeTab: '2' }, // '2' is the key for "Konkursai" tab
        });
    };

    return (
        <Main
            className="competition-detail"
            title={<div>{currentCompetition?.title || 'Konkursas'}</div>}
            headerTitle={<div>{currentCompetition?.title || 'Konkursas'}</div>}
            menuWidth={350}
            menuPlacement="left"
            showFooter={false}
            floatingHeader={false}
            footerContent={<div />}
            floatingFooter
            backLink={false}
            toolbar={[]}
            breadcrumb={null}>
            <Button
                type="text"
                icon={<LeftOutlined />}
                onClick={handleBack}
                style={{ marginBottom: '16px' }}>
                Grįžti atgal
            </Button>
            <Card>
                <Tabs
                    defaultActiveKey="1"
                    items={[
                        {
                            key: '1',
                            label: 'Bendra informacija',
                            children: <CompetitionGeneralDetails competition={currentCompetition} />,
                        },
                        {
                            key: '2',
                            label: 'Laimėtojai',
                            children: <CompetitionWinners competition={currentCompetition} />,
                        },
                    ]} />
            </Card>
        </Main>
    );
};

export default CompetitionDetail;
